import { EasterEgg } from './easter-egg';
export default EasterEgg;
